// extracted by mini-css-extract-plugin
export default {"education":"Education_education__MI2wW","educationTitle":"Education_educationTitle__KcI1N","educationDetails":"Education_educationDetails__U19cy"};